import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../layout";
import Login from "../pages/auth/login";
import AdminDashboard from "../pages/adminDashboard";
import Branches from "../pages/adminDashboard/settings/branches";
import BranchForm from "../pages/adminDashboard/settings/branches/form";
import { useSelector } from "react-redux";
import Settings from "../pages/adminDashboard/settings";
import Docs from "../pages/docs";
import PatientManagement from "../pages/adminDashboard/patient-management/index";
import EditProfile from "../pages/adminDashboard/editProfile";
import Forgotpassword from "../pages/auth/forgotpassword";
import Newpassword from "../pages/auth/newpassword";
import Radiology from "../pages/adminDashboard/radiology";
import ProcedureTracking from "../pages/adminDashboard/procedure-tracking";
import UnlinkedStudies from "../pages/adminDashboard/unlinked-studies";
import ExamList from "../pages/adminDashboard/settings/examList";
import ExamGroup from "../pages/adminDashboard/settings/examGroup";
import ReportTemplates from "../pages/adminDashboard/settings/reportTemplates";
import Appointment from "../pages/adminDashboard/appoinment";
import ImageReport from "../pages/adminDashboard/image-report";
import BillingInvoice from "../pages/adminDashboard/billing-invoice"
import Vouchers from "../pages/adminDashboard/vouchers"
import Analytics from "../pages/adminDashboard/analytics-reporting";
import ReferredPatients from "../pages/adminDashboard/referral";
import ModalityList from "../pages/adminDashboard/settings/modality";
import UserManagement from "../pages/adminDashboard/users";
import PatientAccounts from "../pages/adminDashboard/patientAccounts";
import PatientDashboard from "../pages/patientDashboard";
import MyReports from "../pages/patientDashboard/myReports";
import ExternalReferrers from "../pages/adminDashboard/externalReferrers";
import ExternalDashboard from "../pages/externalDashboard";
import ExternalOrderDetail from "../pages/externalDashboard/orderDetail";
import ExternalImageWorkspace from "../pages/externalDashboard/imageWorkspace";
import LaboratoryDashboard from "../pages/adminDashboard/laboratory";
import LabDepartments from "../pages/adminDashboard/laboratory/settings/departments";
import LabSpecimenTypes from "../pages/adminDashboard/laboratory/settings/specimen-types";
import LabTestCatalog from "../pages/adminDashboard/laboratory/settings/test-catalog";
import LabTestPanels from "../pages/adminDashboard/laboratory/settings/test-panels";
import LabOrders from "../pages/adminDashboard/laboratory/orders";
import LabOrderForm from "../pages/adminDashboard/laboratory/orders/form";
import LabOrderDetail from "../pages/adminDashboard/laboratory/orders/detail";
import LabSpecimens from "../pages/adminDashboard/laboratory/specimens";
import LabResultWorklist from "../pages/adminDashboard/laboratory/results";
import LabResultEntry from "../pages/adminDashboard/laboratory/results/entry";
import LabAuthorizationQueue from "../pages/adminDashboard/laboratory/results/authorization";
import LabAnalyzers from "../pages/adminDashboard/laboratory/analyzers";
import LabAnalyzerConfig from "../pages/adminDashboard/laboratory/analyzers/config";
import LabAnalyzerTestMapping from "../pages/adminDashboard/laboratory/analyzers/test-mapping";
import LabAnalyzerLogs from "../pages/adminDashboard/laboratory/analyzers/logs";
import LabQCDashboard from "../pages/adminDashboard/laboratory/qc";
import LabQCEntry from "../pages/adminDashboard/laboratory/qc/entry";
import LabQCMaterials from "../pages/adminDashboard/laboratory/qc/materials";
import LabEquipment from "../pages/adminDashboard/laboratory/equipment";
import LabInventory from "../pages/adminDashboard/laboratory/inventory";
import LabReports from "../pages/adminDashboard/laboratory/reports";
import LabAnalyticsDashboard from "../pages/adminDashboard/laboratory/analytics";
import LabUnmatchedResults from "../pages/adminDashboard/laboratory/unmatched-results";
import MyLabResults from "../pages/patientDashboard/myLabResults";
import PermissionSettings from "../pages/adminDashboard/settings/permissions";

// Renders the correct dashboard based on stored appMode
const ModeAwareDashboard = () => {
    const storedMode = localStorage.getItem('appMode');
    if (storedMode === 'radiology') return <AdminDashboard />;
    return <Navigate to="laboratory" replace />;
};

function Routing() {
    const { isLoggedIn } = useSelector((state) => state.auth);
    // Per-deployment: hospitals that finalize directly in the Results screen can
    // hide the two-step Authorization queue via features['lis.authorizationQueue'].
    const authQueueEnabled = useSelector((state) => state.hospitalConfig?.features?.['lis.authorizationQueue'] !== false);
    return (
        <Routes>
            <Route element={<Layout layoutName="admin" proctedRoute={true} />}>
                <Route path="admin">
                    <Route index element={<ModeAwareDashboard />} />
                    <Route path="edit-profile" element={<EditProfile />} />
                    <Route path="patient-management" element={<PatientManagement />} />
                    <Route path="radiology" element={<Radiology />} />
                    <Route path="procedure-tracking" element={<ProcedureTracking />} />
                    <Route path="unlinked-studies" element={<UnlinkedStudies />} />
                    <Route path="appointment" element={<Appointment />} />
                    <Route path="image-report" element={<ImageReport />} />
                    <Route path="billing-invoice" element={<BillingInvoice />} />
                    <Route path="vouchers" element={<Vouchers />} />
                    <Route path="anlytics-reporting" element={<Analytics />} />
                    <Route path="referred-list" element={<ReferredPatients />} />
                    <Route path="users" element={<UserManagement />} />
                    <Route path="patient-accounts" element={<PatientAccounts />} />
                    <Route path="external-referrers" element={<ExternalReferrers />} />
                    <Route path="laboratory">
                        <Route index element={<LaboratoryDashboard />} />
                        <Route path="orders" element={<LabOrders />} />
                        <Route path="orders/new" element={<LabOrderForm />} />
                        <Route path="orders/:id" element={<LabOrderDetail />} />
                        <Route path="specimens" element={<LabSpecimens />} />
                        <Route path="results" element={<LabResultWorklist />} />
                        <Route path="results/entry/:id" element={<LabResultEntry />} />
                        {authQueueEnabled && <Route path="results/authorization" element={<LabAuthorizationQueue />} />}
                        <Route path="unmatched-results" element={<LabUnmatchedResults />} />
                        <Route path="analyzers" element={<LabAnalyzers />} />
                        <Route path="analyzers/config" element={<LabAnalyzerConfig />} />
                        <Route path="analyzers/config/:id" element={<LabAnalyzerConfig />} />
                        <Route path="analyzers/test-mapping/:id" element={<LabAnalyzerTestMapping />} />
                        <Route path="analyzers/logs/:id" element={<LabAnalyzerLogs />} />
                        <Route path="qc" element={<LabQCDashboard />} />
                        <Route path="qc/entry" element={<LabQCEntry />} />
                        <Route path="qc/materials" element={<LabQCMaterials />} />
                        <Route path="equipment" element={<LabEquipment />} />
                        <Route path="inventory" element={<LabInventory />} />
                        <Route path="reports" element={<LabReports />} />
                        <Route path="analytics" element={<LabAnalyticsDashboard />} />
                        <Route path="settings/departments" element={<LabDepartments />} />
                        <Route path="settings/specimen-types" element={<LabSpecimenTypes />} />
                        <Route path="settings/test-catalog" element={<LabTestCatalog />} />
                        <Route path="settings/test-panels" element={<LabTestPanels />} />
                    </Route>
                    <Route path="settings">
                        <Route index element={<Settings />} />
                        <Route path="branches" element={<Branches />} />
                        <Route path="exam-list" element={<ExamList />} />
                        <Route path="exam-group" element={<ExamGroup />} />
                        <Route path="modality-list" element={<ModalityList />} />
                        <Route path="report-templates" element={<ReportTemplates />} />
                        <Route path="permissions" element={<PermissionSettings />} />
                    </Route>
                </Route>
            </Route>

            <Route element={<Layout layoutName="patient" proctedRoute={true} />}>
                <Route path="Patient">
                    <Route index element={<PatientDashboard />} />
                    <Route path="my-reports" element={<MyReports />} />
                    <Route path="my-lab-results" element={<MyLabResults />} />
                    <Route path="edit-profile" element={<EditProfile />} />
                </Route>
            </Route>

            <Route element={<Layout layoutName="admin" proctedRoute={true} />}>
                {["phlebotomist", "labTechnician", "labTechnologist", "labSupervisor", "pathologist", "labDirector", "labAdmin"].map(path => (<Route key={path} path={path}>
                    <Route index element={<ModeAwareDashboard />} />
                    <Route path="edit-profile" element={<EditProfile />} />
                    <Route path="patient-management" element={<PatientManagement />} />
                    <Route path="radiology" element={<Radiology />} />
                    <Route path="procedure-tracking" element={<ProcedureTracking />} />
                    <Route path="unlinked-studies" element={<UnlinkedStudies />} />
                    <Route path="appointment" element={<Appointment />} />
                    <Route path="image-report" element={<ImageReport />} />
                    <Route path="billing-invoice" element={<BillingInvoice />} />
                    <Route path="vouchers" element={<Vouchers />} />
                    <Route path="anlytics-reporting" element={<Analytics />} />
                    <Route path="laboratory">
                        <Route index element={<LaboratoryDashboard />} />
                        <Route path="orders" element={<LabOrders />} />
                        <Route path="orders/new" element={<LabOrderForm />} />
                        <Route path="orders/:id" element={<LabOrderDetail />} />
                        <Route path="specimens" element={<LabSpecimens />} />
                        <Route path="results" element={<LabResultWorklist />} />
                        <Route path="results/entry/:id" element={<LabResultEntry />} />
                        {authQueueEnabled && <Route path="results/authorization" element={<LabAuthorizationQueue />} />}
                        <Route path="unmatched-results" element={<LabUnmatchedResults />} />
                        <Route path="analyzers" element={<LabAnalyzers />} />
                        <Route path="analyzers/config" element={<LabAnalyzerConfig />} />
                        <Route path="analyzers/config/:id" element={<LabAnalyzerConfig />} />
                        <Route path="analyzers/test-mapping/:id" element={<LabAnalyzerTestMapping />} />
                        <Route path="analyzers/logs/:id" element={<LabAnalyzerLogs />} />
                        <Route path="qc" element={<LabQCDashboard />} />
                        <Route path="qc/entry" element={<LabQCEntry />} />
                        <Route path="qc/materials" element={<LabQCMaterials />} />
                        <Route path="equipment" element={<LabEquipment />} />
                        <Route path="inventory" element={<LabInventory />} />
                        <Route path="reports" element={<LabReports />} />
                        <Route path="analytics" element={<LabAnalyticsDashboard />} />
                        <Route path="settings/departments" element={<LabDepartments />} />
                        <Route path="settings/specimen-types" element={<LabSpecimenTypes />} />
                        <Route path="settings/test-catalog" element={<LabTestCatalog />} />
                        <Route path="settings/test-panels" element={<LabTestPanels />} />
                    </Route>
                    <Route path="settings">
                        <Route index element={<Settings />} />
                        <Route path="exam-list" element={<ExamList />} />
                        <Route path="exam-group" element={<ExamGroup />} />
                        <Route path="modality-list" element={<ModalityList />} />
                        <Route path="report-templates" element={<ReportTemplates />} />
                    </Route>
                </Route>))}
            </Route>

            {/* Clerical Staff - limited to dashboard, patients, appointments */}
            <Route element={<Layout layoutName="admin" proctedRoute={true} />}>
                <Route path="clericalStaff">
                    <Route index element={<AdminDashboard />} />
                    <Route path="edit-profile" element={<EditProfile />} />
                    <Route path="patient-management" element={<PatientManagement />} />
                    <Route path="appointment" element={<Appointment />} />
                </Route>
            </Route>

            {/* External Access Routes */}
            <Route element={<Layout layoutName="externalReferrer" proctedRoute={true} />}>
                <Route path="external">
                    <Route index element={<ExternalDashboard />} />
                    <Route path="order/:orderId" element={<ExternalOrderDetail />} />
                    <Route path="order/:orderId/images" element={<ExternalImageWorkspace />} />
                </Route>
            </Route>

            <Route element={<Layout layoutName="auth" />}>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<Forgotpassword />} />
                <Route path="/new-password/:token" element={<Newpassword />} />
            </Route>

            <Route element={<Layout layoutName="auth" />}>
                <Route path="/" element={<Login />} />
                <Route path="*" element={<Login />} />
            </Route>

            <Route element={<Layout />}>
                <Route path="/docs" element={<Docs />} />
            </Route>

            {isLoggedIn && <Route path="add/branch" element={<BranchForm onlyForm={true} />} />}
        </Routes>
    )
}

export default Routing;
